import { FormValuesType } from '../../components/investor-management/approver/RiskCategorization';
import { Applicant, ApplicantAddressType, ApplicationProps, Bank, NomineeType } from './api-types';

export type ApplicantNct = Applicant;

export type AuditLogsType = {
  applicationId: string;
  createdAt: string | Date;
  createdBy: string;
  email: string;
  id: string;
  modified_by: string;
  name: string;
  phone: string;
  remarks: string;
  status: string;
  updatedAt: string | Date;
  updatedBy: string;
};

export type DifferenceType = {
  applicationId: string | null;
  createdAt: string | Date | null;
  createdBy: string | null;
  fieldName: string | null;
  id: string | null;
  auditId: string | null;
  newValue: string | null;
  oldValue: string | null;
  recordId: string | null;
  tableName: string | null;
  updatedAt: string | Date | null;
  updatedBy: string | null;
};

export type ApplicationNctProps = ApplicationProps & {
  differences: DifferenceType[];
  audit_logs: AuditLogsType[];
  change_request_status: string;
  cvl_kra_status: string;
  approval_status: string;
  riskCategory: string;
  riskCategoryExplanation: string;
} & FormValuesType;

type DynamicChanges = {
  [key: string]: { new: string; old: string };
};

type Difference = {
  applicationId: number;
} & DynamicChanges;

export type NctRequestData = {
  address: ApplicantAddressType;
  applicationIds: string[];
  applications: ApplicationNctProps[];
  createdAt: string;
  createdBy: string;
  differences: Difference;
  dob: string;
  email: string;
  id: string;
  name: string;
  nationality: string;
  panNumber: string;
  phone: string;
  status: string;
  updatedAt: string;
  updatedBy: string;
  all_change_request_status: string;
  all_cvl_kra_status: string;
};

export type NctRequestDataArray = NctRequestData[];

export type GetAllChangeRequestBody = {
  limit: number;
  page: number;
  sort: string;
  order: string;
  search: string;
  applicationType: string;
  status: string;
  modeOfHolding: string;
  distributorId: string;
  kycStatus: string;
  riskCategory: string;
  schemeId: string;
  planId: string;
  fetch?: string;
};

export type GetAllNctResponseBody = {
  data: NctRequestDataArray;
  limit: number;
  page: number;
  pages: number;
  total: number;
  applicationType: string;
  status: string;
  modeOfHolding: string;
  distributorId: string;
};

export const NCT_APPROVE_SUCCESS = 'NCT_APPROVE_SUCCESS';
export const NCT_APPROVE = 'NCT_APPROVE';

export const NCT_REJECT_SUCCESS = 'NCT_REJECT_SUCCESS';
export const NCT_REJECT = 'NCT_REJECT';

export const GET_NCT_APPLICATION_SUCCESS = 'GET_NCT_APPLICATION_SUCCESS';
export const GET_NCT_APPLICATION = 'GET_NCT_APPLICATION';

export const UPDATE_NCT_APPLICATION_SUCCESS = 'UPDATE_NCT_APPLICATION_SUCCESS';
export const UPDATE_NCT_APPLICATION = 'UPDATE_NCT_APPLICATION';

export const GET_ALL_NCT_APPLICATION_SUCCESS = 'GET_ALL_NCT_APPLICATION_SUCCESS';
export const GET_ALL_NCT_APPLICATION = 'GET_ALL_NCT_APPLICATION';

export const CLEAR_APPLICATION = 'CLEAR_APPLICATION';

export const KYC_REPORTS_SUCCESS = 'KYC_REPORTS_SUCCESS';
export const KYC_REPORTS = 'KYC_REPORTS';

export type KYC_REPORT_TYPE = {
  applicantName: string;
  applicationNumber: string;
  approvedBy: string;
  approvedDate: string | Date;
  fieldName: string;
  id: string;
  oldValue: string;
  initiatedBy: string;
  initiationDate: string | Date;
  newValue: string;
};

export type CVL_KRA_REPORT_TYPE = {
  id: string;
  applicationId: string;
  applicationNumber: string;
  modifiedBy: string;
  createdAt: string;
  remarks: string;
  differences: string;
};

export type KYC_REPORTS_ARRAY_TYPE = KYC_REPORT_TYPE[];
export type KycReportsResponse = {
  data: KYC_REPORTS_ARRAY_TYPE;
  limit: number;
  page: number;
  pages: number;
  total: number;
};

export const FETCH_INVESTOR_KYC_SUCCESS = 'FETCH_INVESTOR_KYC_SUCCESS';
export const FETCH_INVESTOR_KYC = 'FETCH_INVESTOR_KYC';

export type investorManagementFilterType = {
  distributorId: string[];
  applicationType: string[];
  modeOfHolding: string[];
  status: string[];
  kycStatus: string[];
  riskCategory: string[];
  schemeId: string[];
  planId: string[];
  [key: string]: string[] | string | number | null | boolean;
};

export const GET_ALL_PENDING_INVESTORS_SUCCESS = 'GET_ALL_PENDING_INVESTORS_SUCCESS';
export const GET_ALL_PENDING_INVESTORS = 'GET_ALL_PENDING_INVESTORS';

export type PendingInvestorResponseType = Omit<
  ApplicationNctProps,
  'banks' | 'nominees' | 'applicants'
> & {
  investor_applicants: Partial<ApplicantNct>[];
  investor_banks: Bank[];
  investor_nominees: NomineeType[];
};

export type PendingInvestorListResponseType = {
  applications: PendingInvestorResponseType[];
  limit: number;
  page: number;
  pages: number;
  total: number;
};
